import React from 'react'
import { useSelector } from 'react-redux'
import Slider from 'react-slick'
import { Card, Box, CardContent, Divider, Avatar, Typography, Paper, Stack  } from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

import { useDispatch } from 'react-redux';
import { setcurrentPair, setPairType } from '../Trader/tradingSlice';
import { useNavigate } from 'react-router-dom';

const StockSlide = () => {

  const coinRates = useSelector((state) => state.coins.coinRates)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stock = useSelector((state) => state.coins.stock);
  const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);
  
  const settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 6,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  }

  return (
<Card elevation={0} sx={{paddingX: '5px'}} >  
    <Stack sx={{bgcolor: 'inherit', marginTop: '5px'}}>
         {stock.length > 0 &&
            
                <Slider {...settings}>
                {stock.map((coin) => (
                    <Box key={coin.id}
                    onClick={()=>{
                        dispatch(setcurrentPair(`${coin.short_name}`));
                        dispatch(setPairType('stocks'));
                                          
                        setTimeout(() => {
                          navigate('/trading-page');
                        }, 100);
                    }}
                    >
                        <Card elevation={1} sx={{marginX: '2px', paddingY: '5px', borderRadius: '7px', height: 'fit-content'}}>
                                <Box sx={{display: 'flex', marginBottom: '3px', justifyContent: 'space-evenly', alignItems: 'center'}}>
                                <Avatar sx={{height: '30px', width: '30px'}} src={`https://img.logo.dev/ticker/${coin.short_name}?token=pk_Pb2cclXnTuuh7Lsj1Ys7ew&retina=true`} />
                                <Typography variant='button'>
                                       {coin.short_name} 
                                </Typography>
                                </Box>
                                <Divider/>
                                <Box sx={{marginTop: '5px'}}>
                                    <Typography>
                                        {formatPrice(parseFloat(coin.current_price))}
                                    </Typography>
                                    <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                                    <Typography color={parseFloat(coin.change_price) > 0 ? '#198c41' : '#f31348'}>
                                      {coin.change_percentage}
                                    </Typography>
                                    <Typography color={parseFloat(coin.change_price) > 0 ? '#198c41' : '#f31348'}>
                                    {parseFloat(coin.change_price) > 0 ? <ArrowUpwardIcon/> : <ArrowDownwardIcon/> }
                                    </Typography>
                                    </Box>
                                    
                                </Box>
                        </Card>
                    </Box>
                ))}
                </Slider>
          
        }
    </Stack> 
    </Card>
  )
}

export default StockSlide
